// Mirror of AdminPolicy::OWNER_EMAIL (app/policies/admin_policy.rb): the only
// account allowed to sign in on the web. The API is the real gate (/me exposes
// app_admin and the admin endpoints 403 everyone else); this is the UX side.
export const APP_OWNER_EMAIL = 'eduardofiorezi@gmail.com';
